import type { TFunction } from 'i18next';

import { EOnboardingMilestone } from '@feathr/blackbox';

export interface IMilestoneConfig {
  title: string;
  description: string;
  videoDescription?: string;
  videoHeading?: string;
  videoThumbnail?: string;
  videoUrl?: string;
}

export const getMilestoneConfig = (
  milestone: EOnboardingMilestone,
  t: TFunction,
): IMilestoneConfig => {
  const config: Record<EOnboardingMilestone, IMilestoneConfig> = {
    [EOnboardingMilestone.InitialAccountSetup]: {
      title: t('Set up your Account'),
      description: t(
        'Configure billing setup, track and build your audience, authenticate your email domain, etc.',
      ),
      videoHeading: t('Account Setup'),
      videoDescription: t('Watch this to begin setup'),
      videoThumbnail: 'https://cdn.feathr.co/imgs/feathr_lite_account_setup_thumbnail.png',
      videoUrl: 'https://cdn.feathr.co/movs/feathr_lite_account_setup.mp4',
    },
    [EOnboardingMilestone.SingleSendCampaign]: {
      title: t('Publish your first Email Campaign'),
      description: t('Create and send your first email'),
      videoHeading: t('Email Setup'),
      videoDescription: t('Learn more about emails'),
      videoThumbnail: 'https://cdn.feathr.co/imgs/feathr_lite_email_campaign_thumbnail.png',
      videoUrl: 'https://cdn.feathr.co/movs/feathr_lite_email_milestone.mp4',
    },
    [EOnboardingMilestone.RetargetingCampaign]: {
      title: t('Publish your first Ad Campaign'),
      description: t('Set up a retargeting campaign'),
    },
  };

  return config[milestone];
};
